/* eslint-disable react/no-array-index-key */

import React from 'react';
import CheckboxField from '../../../FormFields/CheckboxField';

const desiredShiftsOptions = [
  [
    { id: 1, label: '8 hour days' },
    { id: 2, label: '8 hour nights' },
    { id: 3, label: '8 hour PMs' },
  ],
  [
    { id: 4, label: '12 hour days' },
    { id: 5, label: '12 hour nights' },
    { id: 6, label: '12 hour days PMs' },
  ],
  [
    { id: 7, label: 'Flex Shift' },
    { id: 8, label: 'Any Shift' },
  ],
];

const DesiredShifts = ({ checked, onChange }) => (
  <div className="row">
    <div className="col-xs-12 col-sm-12 col-md-12">
      <div className="form-group mg-top-lg">
        <label htmlFor="employment-occupation">Desired shifts:</label>
        <div className="row">
          {desiredShiftsOptions.map((column, i) => (
            <div key={i} className="col-xs-12 col-sm-4 col-md-3">
              {column.map((shift) => (
                <div key={shift.id} className="checkbox">
                  <label>
                    <CheckboxField
                      label={shift.label}
                      value="1"
                      checked={checked.indexOf(shift.label) > -1}
                      name={shift.label}
                      onChange={onChange}
                    />
                  </label>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default DesiredShifts;
